export const REGEXP = {
  NUMBER: /^\d+$/,
  PHONE: /^01([0|1|6|7|8|9])([0-9]{3,4})([0-9]{4})$/,
  PASSWORD:
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[`~!@#$%^&*()\-_=+\\[{}\]\\|;:'\\",.<>/?])[A-Za-z\d`~!@#$%^&*()\-_=+\\[{}\]\\|;:'\\",.<>/?]{8,20}$/,
  NUMBER_AND_HYPHEN: /[^0-9-]/g,
  NUMBER_COMMA_FORMAT: /\B(?=(\d{3})+(?!\d))/g,
  YYYYMMDD: /^\d{4}\d{2}\d{2}$/,
  RESIDENT_REGISTRATION_NUMBER:
    /^\d{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])\d{7}$/,
  CORPORATE_REGISTRATION_NUMBER: /^\d{6}\d{7}$/,
  COMPANY_REGISTRATION_NUMBER: /^\d{3}\d{2}\d{5}$/,
}
